module.exports = __webpack_public_path__ + "img/button_icon_factura.92a4bc0.svg";